import React, { useLayoutEffect } from "react";
import Footer from "../../components/Layout/Footer";
import SearchModal from "../../components/Layout/Header/SearchModal";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import ServiceDetailsContent from "./ServiceDetailsContent";

// Breadcrumbs Image
import breadcrumbsImg from "../../assets/img/breadcrumbs/2.jpg";

const ServiceDetails = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <React.Fragment>
      {/* breadcrumb-area-start */}
      <SiteBreadcrumb
        breadcrumbsImg={breadcrumbsImg}
        pageTitle="Software Development"
        pageCategory="Services"
        pageName="Software Development"
      />
      {/* breadcrumb-area-end */}

      <ServiceDetailsContent />

      <Footer footerClass="rs-footer" />

      <SearchModal />
    </React.Fragment>
  );
};

export default ServiceDetails;
